import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: ${props => props.$active ? props.$activeFiltersColor : props.$backgroundColor};
  color: ${props => props.$active ? props.$colorActive : props.$color};
  margin: 2rem 2rem 2rem 0;
  cursor: pointer;
  user-select: none;
  font-size: 1.4rem;

  ${props => props.$active ? `
    border: 1px solid ${props.$active && props.$colorActive ? props.$colorActive : props.$color ? props.$color : 'transparent'};
  ` : ''}

  &:hover {
    background-color: ${props => props.$hoverBackgroundColor};
    color: ${props => props.$active ? props.$colorActiveHover : props.$colorHover};
  }

  ${ props => props.$switchButtonThisStyles }
`;
